import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;
const err = (e) => toast.error(e.response?.data?.detail || "Aktion fehlgeschlagen");

const PageRow = ({ page, auth, onChanged }) => {
  const [title, setTitle] = useState(page.title);
  const save = (patch) => axios.put(`${API}/admin/pages/${page.id}`, { title, in_menu: page.in_menu, ...patch }, auth).then(() => onChanged()).catch(err);
  const remove = () => {
    if (!window.confirm(`Seite „${page.title}“ wirklich löschen?`)) return;
    axios.delete(`${API}/admin/pages/${page.id}`, auth).then(() => { toast.success("Seite gelöscht"); onChanged(null, page); }).catch(err);
  };
  return (
    <div className="flex items-center gap-2 py-2 border-b border-[#EEE]" data-testid={`custom-page-row-${page.slug}`}>
      <Input value={title} onChange={(e) => setTitle(e.target.value)} onBlur={() => title !== page.title && save({})} className="h-8 flex-1" data-testid={`custom-page-title-${page.slug}`} />
      <label className="flex items-center gap-1.5 text-xs whitespace-nowrap">
        <Checkbox checked={page.in_menu} onCheckedChange={(v) => save({ in_menu: !!v })} data-testid={`custom-page-menu-${page.slug}`} /> Im Menü
      </label>
      <button type="button" onClick={remove} className="p-1.5 text-red-600 hover:bg-red-50" aria-label="Seite löschen" data-testid={`custom-page-delete-${page.slug}`}><Trash2 className="w-4 h-4" /></button>
    </div>
  );
};

export const CustomPagesDialog = ({ open, onOpenChange, pages, auth, onChanged }) => {
  const [title, setTitle] = useState("");
  const [inMenu, setInMenu] = useState(true);
  const create = (e) => {
    e.preventDefault();
    axios.post(`${API}/admin/pages`, { title, in_menu: inMenu }, auth).then((r) => {
      toast.success(`Seite „${r.data.title}“ angelegt`);
      setTitle("");
      onOpenChange(false);
      onChanged(r.data);
    }).catch(err);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" data-testid="custom-pages-dialog">
        <DialogHeader><DialogTitle>Eigene Seiten</DialogTitle></DialogHeader>
        <form onSubmit={create} className="space-y-3">
          <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="Name der neuen Seite, z.B. Leasing" data-testid="custom-page-new-title" />
          <label className="flex items-center gap-2 text-sm">
            <Checkbox checked={inMenu} onCheckedChange={(v) => setInMenu(!!v)} data-testid="custom-page-new-menu" /> Als Menüpunkt oben anzeigen
          </label>
          <Button type="submit" disabled={!title.trim()} className="w-full bg-[#EFDF00] text-black hover:bg-[#D9C900] font-bold" data-testid="custom-page-create-btn">Seite anlegen</Button>
        </form>
        {pages.length > 0 && (
          <div className="pt-2">
            <p className="text-xs font-bold uppercase tracking-wide text-[#555] mb-1">Vorhandene Seiten</p>
            {pages.map((p) => <PageRow key={p.id} page={p} auth={auth} onChanged={onChanged} />)}
          </div>
        )}
        <p className="text-xs text-[#888B8D]">Neue Seiten und Menüpunkte sind sofort sichtbar. Den Inhalt gestaltest du im Editor und machst ihn mit „Veröffentlichen“ live.</p>
      </DialogContent>
    </Dialog>
  );
};
